import { TextButton } from '@creditornot/cb-button';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BulkActions } from './BulkActions';

type Props = {
  allOffersCount: number;
  disabled: boolean;
  onDeselectAll: () => void;
  onSelectAll: () => void;
  selectedIds: Set<string>;
};

const Root = styled.div`
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
  padding: 0 24px;
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SelectAllButton = styled(TextButton).attrs({ variant: 'blue' })``;

const DeselectAllButton = styled(TextButton).attrs({ variant: 'red' })``;

export const BulkActionsToolbar = ({ allOffersCount, disabled, onSelectAll, onDeselectAll, selectedIds }: Props) => {
  const hasOffersSelected = selectedIds.size > 0;
  const allOffersSelected = selectedIds.size === allOffersCount;

  return (
    <Root>
      <Buttons>
        {!allOffersSelected && (
          <SelectAllButton disabled={disabled} onClick={onSelectAll}>
            <FormattedMessage
              id={
                allOffersCount === 1
                  ? 'menu.bulkActions.selectItemsWithCount'
                  : 'menu.bulkActions.selectAllItemsWithCount'
              }
              values={{ count: allOffersCount }}
            />
          </SelectAllButton>
        )}
        {hasOffersSelected && (
          <DeselectAllButton onClick={onDeselectAll} disabled={disabled}>
            <FormattedMessage id="menu.bulkActions.deselectItemsWithCount" values={{ count: selectedIds.size }} />
          </DeselectAllButton>
        )}
      </Buttons>
      {hasOffersSelected && !disabled && <BulkActions selectedIds={selectedIds} />}
    </Root>
  );
};
